// extracted by mini-css-extract-plugin
module.exports = {"wechat":"Wechat_index_wechat__3Eh05","left-img":"Wechat_index_left-img__1Wg4O","phoneMove":"Wechat_index_phoneMove__fNy0e"};